import Api from '@/providers/Api'
import * as _ from 'lodash'

export default {
    // helper method to populate retrofit device options for other models
    async loadRetrofitDeviceOptions (modelField, model) {
        let manufacturer = model.retrofit_manufacturer_id
        let on_road = model.on_road
        let filters = {
            on_road: { field: 'on_road', value: +on_road },
            manufacturer_id: { field: 'manufacturer_id', value: +manufacturer },
        }
        const retrofit_devices = await Api.getItems(null, 'retrofit-device', filters)
        modelField.options = _.map(retrofit_devices, (device) => {
            return {
                value: device.id, text: device.name
            }
        })
    }
}
